module.exports = __webpack_public_path__ + "media/_archive/C-894a221f.png";